export interface IUser {
  id: number;
  email: string;
  culture: string;
  isXenaSuporter: boolean;
  providerId: number;
}